import { Button } from '@mui/material';

const CustomButton = ({
    variant = 'contained',
    color = 'primary',
    children,
    sx = {},
    height = '35px',
    fullWidth = false,
    fullWidthMobile = false,
    fullWidthDesktop = false,
    ...props
}) => {
    if (fullWidth) {
        fullWidthDesktop = true;
        fullWidthMobile = true;
    }

    const responsiveSx = {
        width: 'auto',
        ...(fullWidthMobile && {
            width: '100%',
            '@media (min-width: 900px)': {
                width: 'auto',
            },
        }),
        ...(fullWidthDesktop && {
            '@media (min-width: 900px)': {
                width: '100%',
            },
        }),
    };

    return (
        <Button variant={variant} color={color} sx={{ ...responsiveSx, ...sx, height: height }} {...props}>
            {children}
        </Button>
    );
};

export default CustomButton;
